"use strict";
/**
 * Utility functions for passwords
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStrong = void 0;
// Checks if the provided password is considered "strong"
var isStrong = function (password) {
    if (password) {
        // At least eight characters, one uppercase letter, one lowercase letter, one number and one special character
        var regex = new RegExp(/^(?=\S*[a-z])(?=\S*[A-Z])(?=\S*\d)(?=\S*[^\w\s])\S{9,}$/);
        return regex.test(password);
    }
    return false;
};
exports.isStrong = isStrong;
